/**
 * The minimum width for a tile in the current layout. When implementing the tile container make sure to set the min width to this variable
 */
export const tileMinWidth = 280;
